import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Dashboard from './pages/Dashboard'
import Landing from './pages/Landing'
import Register from './pages/Register'
import RequireAuth from './routes/RequireAuth'
import RequireAdmin from './routes/RequireAdmin'
import AdminPortal from './pages/AdminPortal'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { useMobileAuth } from './lib/useMobileAuth'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <AppShell />
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App

function AppShell() {
  const { isAuthenticated, isGuest, isLoading, user } = useAuth()
  
  // Handle mobile browser authentication state
  useMobileAuth()
  
  // Debug logging
  console.log('AppShell: Auth state', { isAuthenticated, isGuest, isLoading, user: user?.email })
  
  // Show loading state while initializing auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-animated-gradient-light">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-orange mx-auto mb-4"></div>
          <p className="text-black">Loading...</p>
        </div>
      </div>
    )
  }
  
  return (
    <Routes>
      {/* Admin Portal - Separate layout without main app header/footer */}
      <Route path="/admin/*" element={
        <RequireAdmin>
          <AdminPortal />
        </RequireAdmin>
      } />
      
      {/* Main App - Standard layout with header/footer */}
      <Route path="/*" element={
        <div className={`min-h-screen flex flex-col ${(isAuthenticated || isGuest) ? 'bg-animated-gradient-light' : 'bg-brand-base'}`}>
          <Header />
          <main className="pt-16 flex-1">
            <Routes>
              <Route path="/" element={
                (isAuthenticated || isGuest) ? <Navigate to="/dashboard" replace /> : <Landing />
              } />
              <Route path="/dashboard" element={
                (isAuthenticated || isGuest) ? <Dashboard /> : <RequireAuth><Dashboard /></RequireAuth>
              } />
              {/* Login page removed - not accessible */}
              <Route path="/auth/register" element={
                isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />
              } />
            </Routes>
          </main>
          <Footer />
          {/* <DebugPanel /> */}
        </div>
      } />
    </Routes>
  )
}
